import {makeVar} from '@apollo/client';
import {CategoryModels, Dealer, ModelConfig} from '../typing/model';
import { Offer } from '../typing/offer';
import { ModalDisplayMode } from '../typing/modal-display';

export const modelsConfigVar = makeVar<CategoryModels[]>([]);

export interface GlobalModelData {
  modelName?: string;
  year: number;
  slug?: string;
}
export const globalModelData = makeVar<GlobalModelData | undefined>(undefined);

export const modelConfiguration = makeVar<ModelConfig | undefined>(undefined);


export interface ModalsData {
  offer?: Offer;
  dealer?: Dealer;
  active: boolean;
  mode?: ModalDisplayMode;
  urlRedirect?: string;
  model?: ModelConfig;
}
export const modalsData = makeVar<ModalsData>({ active: false });
